module.exports = __webpack_public_path__ + "static/img/so4_3.89a1eed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_3.jpg
// module id = yOdq
// module chunks = 11